import React from 'react'
import { useFormik } from 'formik'
import { FormattedMessage, useIntl } from 'react-intl'
import {
  FormControl, FormLabel, RadioGroup, FormControlLabel, Radio, Box, Button
} from '@material-ui/core'
import { InvoiceSignCertificateFormValidation } from '../../../../utils/validationSchema'
import { FormLoader } from '../../../Loader/FormLoader'
import { useStyles } from './Styles'
import VerifiedUserIcon from '@material-ui/icons/VerifiedUser'
import Alert from '@material-ui/lab/Alert'
import Configuration from '../../../../Services/Api/Configuration'

const InvoiceSignCertificates = ({ certificates, certificatesLoading, invoiceSubmissionLoading, certificatesFinishRecall, refreshListingData, onSubmit, cancelDialog, formClasses, isDraft }) => {
  const intl = useIntl()
  const classes = useStyles()
  const certificateForm = useFormik({
    initialValues: {
      certificateSerialNumber: ''
    },
    validateOnBlur: false,
    validateOnChange: true,
    validateOnMount: true,
    // isInitialValid: false,
    validationSchema: InvoiceSignCertificateFormValidation,
    onSubmit: ((values, actions) => {
      onSubmit(values?.certificateSerialNumber, cancelDialog)
    })
  })

  const handleCertificatesChange = (e) => {
    !!e?.preventDefault && e.preventDefault()
    !!e?.stopPropagation && e.stopPropagation()
    certificateForm.setFieldValue('certificateSerialNumber', e.target.value)
  }

  return (
    <Box px={!!isDraft ? 0 : 4} pt={!!isDraft ? 0 : 3} pb={!!isDraft ? 0 : 4}>
      <form onSubmit={certificateForm.handleSubmit} noValidate autoComplete="off"
            className={formClasses.formWrapper}>
        {!!certificates?.length ?
          <FormControl component="fieldset" className={classes.CertificatesWrapper}>
            <FormLabel component="legend" className={classes.CertificatesLabel}><FormattedMessage
              id='Fields.label.certificateSerialNumber'/></FormLabel>
            <RadioGroup aria-label={intl.formatMessage({ id: 'Fields.label.certificateSerialNumber' })}
                        className={classes.CertificatesContainer} onChange={handleCertificatesChange}
                        name="certificateSerialNumber" value={certificateForm.values.certificateSerialNumber}>
              {certificates?.map(certificate =>
                <FormControlLabel key={certificate?.serialNumber} value={certificate?.serialNumber} control={<Radio/>}
                                  className={classes.CertificateWrapper + (certificateForm.values.certificateSerialNumber === certificate?.serialNumber ? ' selected' : '')}
                                  label={
                                    <div className={classes.CertificateContainer}>
                                      <VerifiedUserIcon/>
                                      <div className={classes.CertificateContent}>
                                        <div className={classes.CertificateHeader}>
                                          <span>{certificate?.serialNumber}</span>
                                          <span>( {certificate?.emailAddress} )</span>
                                        </div>
                                        <strong>{certificate?.issuedTo}</strong>
                                        <div className={classes.CertificateFooter}>
                                    <span><FormattedMessage
                                      id='Fields.label.nationalID'/>: {certificate?.nationalID}</span>
                                          <span className={'error'}>(<FormattedMessage
                                            id='Fields.label.expiryDate'/>:{certificate?.expiryDate})</span>
                                        </div>
                                      </div>
                                    </div>
                                  }/>
              )}
            </RadioGroup>
          </FormControl> :
          (!!certificatesFinishRecall && <Alert severity="error">
            <FormattedMessage id='TokenCertificates.AlertError'
            values={{link: <a href={Configuration.WEBSIGNCLIENT_URL} target={'_blank'} rel={'noreferrer'}><FormattedMessage id='TokenCertificates.AlertError.link'/></a>}}/>
          </Alert>)
        }

        <div className={formClasses.FormSubmitRow + ' between'}>
          <Button variant='contained' size={'large'} color={'secondary'}
                  onClick={refreshListingData}
                  disabled={certificateForm.isSubmitting || !!certificatesLoading}
          >
            <FormattedMessage id='invoiceSteps.RefreshCertificate'/>
          </Button>
          <div>
            <Button type="submit" variant='contained' size={'large'} color={'secondary'}
                    onClick={certificateForm.handleSubmit}
                    disabled={certificateForm.isSubmitting || !certificateForm.isValid}
            >
              <FormattedMessage id='invoiceSteps.SignNow'/>
            </Button>
            <Button variant='outlined' color='secondary'
                    onClick={cancelDialog} className={'cancel'}>
              <FormattedMessage id='invoiceSteps.Cancel'/>
            </Button>
          </div>
        </div>
        {(!!certificateForm.isSubmitting || !!certificatesLoading || !!invoiceSubmissionLoading) &&
        <FormLoader loading={true}/>}
      </form>
    </Box>
  )
}

export default InvoiceSignCertificates
